<template>
  <section>
    <div class="chart-section-header">{{ sectionTitle }}</div>
    <div class="chart-section-body">
      <slot name="chart"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "chartSection",
  props: {
    sectionTitle: {
      type: String
    },
    chartTitle1: {
      type: String
    },
    chartTitle2: {
      type: String
    }
  }
};
</script>
